import * as React from 'react';

export interface AppContext {
  on?: boolean,
}

const ctxt = React.createContext<AppContext>({on: false});

export const AppContextProvider = ctxt.Provider;
  
export const AppContextConsumer = ctxt.Consumer;


// WEBPACK FOOTER //
// ./src/store/context.tsx